/**
 * Genesis can show its interface in Chinese (account menu → language). Labels
 * that appear everywhere (navigation, page states) come in both languages;
 * the rest of the interface is in English.
 */
export const isZh = (): boolean =>
  typeof window !== 'undefined' && (window as unknown as { __APP_LANGUAGE__?: string }).__APP_LANGUAGE__ === 'zh';

export const tr = (en: string, zh?: string): string => (zh && isZh() ? zh : en);
